// extracted by mini-css-extract-plugin
export default {"authButton":"CustomLinkAuthBtn_authButton__6w8sW","authButtonText":"CustomLinkAuthBtn_authButtonText__+rK1K"};